export default {"src":"/login-app/[GIT_HASH]/_next/static/media/parenthesis.d87cff94.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};